var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"data-table data-table-middle data-table-striped data-table-sm data-table-responsive text-sm"},[_c('thead',[_vm._t("columnHeaders")],2),_c('tbody',[_vm._t("rowData")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }